export default __webpack_public_path__ + "static/fifth-c874782ee77040d3d5e8ea351b21fdb1.png";